import { getDataPaths, concatWithSymbol } from '@custouch/proxy-use'
export async function getPath(id, moduleId){
    const [ path ] = await getDataPaths({dataHierarchyId: id,dataModuleId: moduleId})
    let curH = path.dataHierarchy
    const hInfos = []
    while (curH) {
        hInfos.push(Object.assign({name:curH.name},curH.detail))
        curH = curH.dataHierarchy
    }
    return { hInfos, path: concatWithSymbol(hInfos.map(t => t.name)) }
}
export async function getRowPath(id, moduleId, hierarchyId){
    const [ path ] = await getDataPaths({dataRowId: id,dataModuleId: moduleId,dataHierarchyId: hierarchyId})
    let curH = path.dataHierarchy
    const hInfos = []
    while (curH) {
        hInfos.push(Object.assign({name:curH.name},curH.detail))
        curH = curH.dataHierarchy
    }
    let index = hInfos.findIndex(item=>item.name === '默认')
    if(index > -1){
        hInfos.splice(index,1)
    }
    return { hInfos, path: concatWithSymbol(hInfos.map(t => t.name)) }
}

const { poolId } = window.env.VITE_DATA
export const NLY_PID_STR = [poolId, null, null, null].join(',')
export function getCmsStr(data){
    const cmsGroup = [
        poolId,
        data.mId,
        data.hId,
        data.rId
    ]
    const cmsJ = cmsGroup.join(',')
    return NLY_PID_STR === cmsJ ? undefined : cmsJ
}